// Информация о ФИО

import utils from "../utils";

const GENDER_SIGN = {
    MALE: "♂",
    FEMALE: "♀",
    UNKNOWN: "",
};

const GENDER_DESCRIPTION = {
    MALE: "мужской",
    FEMALE: "женский",
    UNKNOWN: "неизвестен",
};

const isAllowedPartial = fio => {
    if (fio.name) return false;
    const onlyFio = fio.surname && !fio.patronymic;
    const onlyPatronymic = fio.patronymic && !fio.surname;
    return onlyFio || onlyPatronymic;
};

export default {
    fullname(fio) {
        return utils.join([fio.surname, fio.name, fio.patronymic], " ");
    },

    gender(fio) {
        if (["MALE", "Мужской", "М"].indexOf(fio.gender) !== -1) {
            return "MALE";
        }
        if (["FEMALE", "Женский", "Ж"].indexOf(fio.gender) !== -1) {
            return "FEMALE";
        }
        return "UNKNOWN";
    },

    genderSign(fio) {
        return GENDER_SIGN[this.gender(fio)];
    },

    genderDescription(fio) {
        return GENDER_DESCRIPTION[this.gender(fio)];
    },

    genderWithSign(fio) {
        return `${this.genderSign(fio)} ${this.genderDescription(fio)}`;
    },

    isGood(fio) {
        return (fio.qc?.toString() === "0" || isAllowedPartial(fio));
    },

    validationMessage(fio) {
        if (!Object.keys(fio).length) return "";

        if (fio.qc?.toString() !== "0" && !isAllowedPartial(fio)) {
            return "Неизвестное ФИО";
        }

        const emptyParts = [
            {
                value: fio.surname,
                text: "фамилию",
            },
            {
                value: fio.name,
                text: "имя",
            },
            {
                value: fio.patronymic,
                text: "отчество",
            },
        ].filter(part => !part.value);

        if (emptyParts.length) {
            const text = `Еще можно указать ${emptyParts[0].text}`;
            if (emptyParts.length === 1) return text;
            return text + (emptyParts.length === 2
                ? ` и ${emptyParts[1].text}`
                : `, ${emptyParts[1].text} и ${emptyParts[2].text}`);
        }

        return "";
    },
};
